"use strict";

var _toConsumableArray = function (arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) arr2[i] = arr[i]; return arr2; } else { return Array.from(arr); } };

module.exports = function (ngModule) {
  ngModule.factory("formlyWarn", ["formlyConfig", "formlyErrorAndWarningsUrlPrefix", "$log", function (formlyConfig, formlyErrorAndWarningsUrlPrefix, $log) {
    return function warn() {
      if (!formlyConfig.disableWarnings) {
        var args = Array.prototype.slice.call(arguments);
        var warnInfoSlug = args.shift();
        args.unshift("Formly Warning:");
        args.push("" + formlyErrorAndWarningsUrlPrefix + "" + warnInfoSlug);
        $log.warn.apply($log, _toConsumableArray(args));
      }
    };
  }]);
};


/*****************
 ** WEBPACK FOOTER
 ** ./services/formlyWarn.js
 ** module id = 21
 ** module chunks = 0
 **/